export default __webpack_public_path__ + "static/media/iForfeTRI2019_bIANCO_DEF.c6bba088.png";